<template lang="pug">
shListData(title="Reembolsos" resolver="refunds" keyData="refund" component="shRefund")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Deliveries',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/refund/Refunds.vue